// extracted by mini-css-extract-plugin
module.exports = {"desc":"MigrateStaffAccountSuccess_desc__3wlWb","cta":"MigrateStaffAccountSuccess_cta__1vjeh"};